// extracted by mini-css-extract-plugin
module.exports = {"container":"warning-popup-container__2TAg7","text":"warning-popup-text__3gh_r","delete_button":"warning-popup-delete_button__1PcXM","arrow":"warning-popup-arrow__1jkYr"};